import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark1Small"><Path d="M7.5 13.125L10.875 16.5L16.5 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark1Small;
